import React, { useEffect, useState } from "react";
import intl from 'react-intl-universal';
import { Button, DatePicker } from "antd";
import moment from 'moment';
import './ShareDatePicking.scss';

export default function ShareDatePicking({
    onChange
}: {
    onChange: (date?: moment.Moment) => any;
}) {
    const [dateTime, setDateTime] = useState<moment.Moment>();

    useEffect(() => {
        if (typeof dateTime !== 'undefined') {
            onChange(dateTime);
        }
    }, [dateTime]);

    function changeDate(value) {
        const dateTime = moment(value);
        setDateTime(dateTime);
        setOpen(false);
    }
    function cleanDateTime() {
        setDateTime(null);
        setOpen(false);
    }

    let content = intl.get('shareDlg.ShareWithEmail.addDeadline');
    let footerBtn = intl.get('collaboration.sharedList.SharedTableAction.cancelDateTime');
    if (dateTime) {
        content = `${intl.get('shareDlg.ShareWithEmail.DueBy')} ${moment(dateTime).format('YYYY/MM/DD HH:mm')}`;
        footerBtn = intl.get('collaboration.sharedList.SharedTableAction.removeDateTime');
    }

    const [open, setOpen] = useState(false);
    return (
        <label className="dd-share__pick-label">
            <span onClick={() => setOpen(true)}>{content}</span>
            <DatePicker
                className={'dd-share__date-picker__input'}
                dropdownClassName={'dd-share__date-picker__dropdown'}
                format={'YYYY/MM/DD HH:mm'}
                size={'small'}
                showTime={{ format: 'HH:mm' }}
                open={open}
                showToday={false}
                disabledDate={disabledDate}
                disabledTime={disabledDateTime}
                onBlur={() => setOpen(false)}
                onOk={changeDate}
                renderExtraFooter={() => (
                    <Button
                        type="primary"
                        className="cancel-date-btn"
                        onClick={cleanDateTime}
                    >{footerBtn}</Button>
                )}
            />
        </label>
    )
}

function disabledDate(time: moment.Moment) {
    if (!time) return false;
    return moment().isAfter(time, 'day');
}

function disabledDateTime(cur: moment.Moment) {
    if (!cur) {
        return {
            disabledHours: () => range(0, 23),
            disabledMinutes: () => range(0, 59)
        };
    }
    const now = moment();
    const nowHours = now.hour();//0~23
    const currentMinutes = now.minute();//0~59
    const checkedHours = cur.hour();

    if (now.format("YYYYMMDD") === cur.format("YYYYMMDD")) {
        const disable: {
            disabledHours?: () => number[];
            disabledMinutes?: () => number[];
        } = {
            disabledHours: () => range(0, nowHours - 1),
        };
        if (nowHours === checkedHours) {
            disable.disabledMinutes = () => range(0, currentMinutes - 1)
        }
        return disable;
    }
}

function range(start: number, end: number) {
    const result: number[] = [];
    for (let i = start; i <= end; i++) {
        result.push(i);
    }
    return result;
}
